/* eslint-disable no-unused-vars */
import TextField from 'forms/shared/fields/text'
import { connect } from 'react-redux'
import React, { useMemo, useState } from 'react'
import { Field } from 'redux-form'
import TextArea from 'forms/shared/fields/text-area'
import SelectField from 'forms/shared/fields/select'
import PropTypes from 'prop-types'
import buildingData from 'constants/building-data'
import { FORM_ERROR_CLASS } from 'constants/css-style'
import DatePickerDropdownField from 'forms/shared/fields/date-picker-dropdown'
import BuildingSizeNumber from './building-size-number'

const inputErrorClass = `border-red-500 leading-tight`

const inputClass =
  'block placeholder-secondary-greyborder border bg-white border-grey-light w-full px-4 py-3 rounded focus:border-primary-orange'
const BuildingInquireFields = ({ area_unit = '' }) => {
  const options = useMemo(() => {
    if (area_unit && buildingData.headcounts) {
      return buildingData.headcounts.map((opt) => {
        if (opt.format) return { ...opt, label: `${opt.label} (${area_unit})` }
        return opt
      })
    }
    return buildingData.headcounts
  }, [area_unit, buildingData.headcounts])

  const [isNoteFocused, setIsNoteFocused] = useState(false)

  return (
    <>
      <Field
        type={'text'}
        name={'firstName'}
        placeholder={'Full Name'}
        groupClassName="mb-4"
        inputClassName={inputClass}
        inputErrorClassName={inputErrorClass}
        errorClassName="text-red-500 text-xs italic"
        component={TextField}
      />
      <Field
        type={'email'}
        name={'email'}
        placeholder={'Email'}
        groupClassName="mb-4"
        inputClassName={inputClass}
        inputErrorClassName={inputErrorClass}
        errorClassName="text-red-500 text-xs italic"
        component={TextField}
      />
      <Field
        type={'text'}
        name={'phone'}
        placeholder={'Mobile Number'}
        inputClassName={inputClass}
        inputErrorClassName={inputErrorClass}
        errorClassName="text-red-500 text-xs italic"
        component={TextField}
      />
      <div className="mb-4">
        <label className="mt-4 mb-2 block text-left">Expected office size or headcount</label>
        <div className="flex">
          <Field
            type={'text'}
            name={'expected_number_office_size_or_headcount'}
            groupClassName="w-1/2"
            inputClassName={`${inputClass} text-center`}
            inputErrorClassName={inputErrorClass}
            errorClassName="text-red-500 text-xs italic"
            component={BuildingSizeNumber}
          />
          <Field
            name="expected_office_size_or_headcount"
            groupClassName="w-1/2"
            options={options}
            inputClassName={'select text-xs outline-none'}
            errorClassName="text-red-500 text-xs italic"
            customStyles={{
              control: (styles) => ({
                ...styles,
                paddingBottom: '6px',
                paddingTop: '6px',
              }),
            }}
            component={SelectField}
          />
        </div>
      </div>
      <div className="mb-4">
        <label className="block mb-2 text-left">Expected lease start date</label>
        <Field
          type="dropdown"
          name="expected_lease_start_date"
          placeholder="Select a date"
          showIcon
          pickerClassName="w-full"
          boxClassName="w-full border rounded-lg bg-white p-3 cursor-pointer position-absolute"
          showText={false}
          placeholderClassName="pl-2 text-sm w-full text-primary-lightgray"
          groupClassName="w-full position-relative"
          inputClassName="pl-1 regular text-sm w-full"
          inputGroupClassName=""
          inputErrorClassName="border-action-danger"
          errorClassName={FORM_ERROR_CLASS}
          component={DatePickerDropdownField}
        />
      </div>
      <Field
        type={'text'}
        name={'notes'}
        placeholder="Note"
        groupClassName="mb-4"
        rows={isNoteFocused ? 4 : 1}
        onFocus={() => {
          setIsNoteFocused(true)
        }}
        onBlur={() => {
          setIsNoteFocused(false)
        }}
        inputClassName={inputClass}
        inputErrorClassName={inputErrorClass}
        errorClassName="text-red-500 text-xs italic"
        component={TextArea}
      />
    </>
  )
}

BuildingInquireFields.propTypes = {
  form: PropTypes.string,
  dispatch: PropTypes.func,
  area_unit: PropTypes.string,
}

const mapStateToProps = ({ building }) => ({
  area_unit: building.public.details.area_unit,
})

export default connect(mapStateToProps)(BuildingInquireFields)
